<template>
  <div class="account-com">
    <div class="content" v-show="showRegister">
      <div class="d-flex justify-space-between align-center mb-3">
        <p class="content-title" style="margin: auto;">{{ $t('register.registration') }}</p>
        <div class="close-btn" @click="showChooseTypeRegisterModal">&times;</div>
      </div>
      <transition name="fade" mode="out-in" enter-active-class="fadeInLeft" leave-active-class="fadeOutRight">
        <div class="submit-container" v-if="!showRegisterForm">
          <v-btn
            :loading="commitLoading"
            @click="showRegisterModal"
            block
            class="btn-common"
            x-large
            :large="$vuetify.breakpoint.xsOnly"
          >
            {{ $t('actions.registNow') }}
          </v-btn>
        </div>

        <div v-else>
          <ManualRegister />
        </div>
      </transition>
      <!--已有账户---end-->
    </div>
    <PromoMaxRegModal
      v-if="upgradeModalShow"
      :show.sync="upgradeModalShow"
      :row-padding="'0'"
      :medium="true"
      v-model="upgradeModalShow"
      :pkg-type="maxWalletPkgType"
      :title="''"
      :layout="false"
      @showMaxRegister="showMaxRegister"
      @showRegisterForm="showRegisterModal"
    />
    <MaxRegisterModal2
      v-if="maxWalletModalShow"
      :show.sync="maxWalletModalShow"
      :row-padding="'0'"
      :medium="true"
      v-model="maxWalletModalShow"
      :pkg-type="maxWalletPkgType"
      :title="''"
      @showMaxRegister="showRegisterModal"
      @showRegisterForm="showChooseTypeRegisterModal"
    />
    <ChooseTypeRegister
      v-if="chooseTypeRegisterShow"
      :show.sync="chooseTypeRegisterShow"
      :row-padding="'0'"
      v-model="chooseTypeRegisterShow"
      :title="''"
      :layout="false"
      @showMaxRegister="showUpgradeModal"
      @showRegisterForm="showRegisterModal"
      @redirectToHome="redirectToHome"
    >
    </ChooseTypeRegister>
    <!--MaxRegisterModal
      v-if="maxWalletModalShow"
      :show.sync="maxWalletModalShow"
      :pkg-type="maxWalletPkgType"
      :title="$t('max.register.title.registration')"
      :desc="$t('max.register.desc.registration')"
      :row-padding="'0'"
      :medium="true"
      v-model="maxWalletModalShow"
    />-->
    <!--<bind-phone-modal v-model="bindPhoneModalShow"></bind-phone-modal>-->
  </div>
</template>
<script>
import index from './regist-index';
export default index;
</script>

<style lang="stylus" scoped>
@import "./regist.scoped.styl";
@import "../common.styl"
.mxw-wallet-benefit {
  background: #F5F5F8 0% 0% no-repeat padding-box;
  padding: 10px;
  margin-bottom: 15px;
}

.register-page {
  margin-top: 0px;
}

.mxw-wallet-benefit td {
  font-size: 14px;
}

.download-model {
  background: red;
  padding: 20px;
}

.bottom-section {
  background-color: #F5F5F8;
  margin: 10px -15px -15px -15px;
  min-height: 150px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 20px;

  .img-step {
    max-width: 100px;
    width: 100%;
  }
}
</style>
